import React, { useEffect, useState } from "react";
import { useLoader } from "../../../../context/LoaderProvider.jsx";

const filterSelectStyle = {
    backgroundColor: "#b15cd6",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 10px",
};

const filterButtonStyle = {
    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 15px",
};

const GroceryOrderdetails = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        const controller = new AbortController();

        const fetchOrders = async () => {
            try {
                showLoader();
                const token = localStorage.getItem("authToken");
                const headers = token ? { Authorization: `Bearer ${token}` } : {};

                const res = await fetch(
                    "http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/admin/grocery/orders/all",
                    { method: "GET", headers, signal: controller.signal }
                );

                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

                const fetchedApiData = await res.json();
                // console.log("✅ API Response:", fetchedApiData);

                // ✅ Handle data in case API wraps inside "data" or returns array directly
                const normalizedData = Array.isArray(fetchedApiData)
                    ? fetchedApiData
                    : Array.isArray(fetchedApiData.data)
                        ? fetchedApiData.data
                        : [];

                // Normalize key naming (orderDateTime vs orderDateAndTime)
                const finalData = normalizedData.map((item) => ({
                    ...item,
                    orderDateAndTime: item.orderDateAndTime || item.orderDateTime || "",
                }));

                // console.log("✅ Normalized Orders:", finalData);
                setData(finalData);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("❌ Fetching error:", err);
                    alert("Failed to load orders. Please try again later.");
                }
                setData([]);
            } finally {
                hideLoader();
            }
        };

        fetchOrders();
        return () => controller.abort();
    }, [showLoader, hideLoader]);

    // ✅ Filter data by selected date
    useEffect(() => {
        let filtered = [...data];
        if (selectedDate) {
            const selected = new Date(selectedDate);
            selected.setHours(0, 0, 0, 0);
            const selectedEnd = new Date(selected);
            selectedEnd.setHours(23, 59, 59, 999);
            filtered = filtered.filter((item) => {
                const orderDate = new Date(item.orderDateAndTime);
                return orderDate >= selected && orderDate <= selectedEnd;
            });
        }
        setFilteredData(filtered);
    }, [selectedDate, data]);

    // ✅ CSV Export (with safe escaping)
    const escapeCSV = (value) =>
        typeof value === "string"
            ? `"${value.replace(/"/g, '""')}"`
            : value ?? "";

    const handleExport = () => {
        if (filteredData.length === 0) {
            alert("There is no data to export based on the current filters.");
            return;
        }

        const headers = [
            "S.NO",
            "Order ID",
            "Vendor ID",
            "User ID",
            "Location",
            "Date",
            "Time",
            "Payment Method",
            "Payment Status",
            "Order Status",
            "Total",
            "Category",
            "Item Name",
            "Price",
            "Quantity",
            "Cancel Reason",
        ];

        const csvRows = filteredData.map((item, index) => {
            const orderItem = item.orderItems?.[0] || {};
            return [
                index + 1,
                escapeCSV(item.orderId),
                escapeCSV(item.vendorId),
                escapeCSV(item.userId),
                escapeCSV(item.location),
                escapeCSV(
                    item.orderDateAndTime
                        ? new Date(item.orderDateAndTime).toLocaleDateString()
                        : "N/A"
                ),
                escapeCSV(
                    item.orderDateAndTime
                        ? new Date(item.orderDateAndTime).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                        })
                        : "N/A"
                ),
                escapeCSV(item.paymentMethod),
                escapeCSV(item.paymentStatus),
                escapeCSV(item.orderStatus),
                escapeCSV(item.total),
                escapeCSV(orderItem.groceryCategory),
                escapeCSV(orderItem.groceryItemName),
                escapeCSV(orderItem.groceryPrice),
                escapeCSV(orderItem.quantity),
                escapeCSV(item.cancelReason),
            ];
        });

        const csvString = [
            headers.join(","),
            ...csvRows.map((row) => row.join(",")),
        ].join("\r\n");

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "grocery_orders.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <div style={{ padding: "20px", marginTop: "-55px" }}>
            {/* Filters */}
            <div
                className="d-flex flex-wrap align-items-center mb-3 pt-5"
                style={{ gap: "10px" }}
            >
                {/* Date Picker Filter */}
                <div>
                    <input
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        style={filterSelectStyle}
                    />
                </div>

                <div style={{ marginLeft: "auto" }}>
                    <button
                        onClick={handleExport}
                        style={{
                            ...filterButtonStyle,
                            opacity: filteredData.length === 0 ? 0.6 : 1,
                            cursor: filteredData.length === 0 ? "not-allowed" : "pointer",
                        }}
                        disabled={filteredData.length === 0}
                    >
                        Export
                    </button>
                </div>
            </div>

            {/* Table */}
            <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                    <thead>
                        <tr>
                            <th style={headerStyle}>Order ID</th>
                            <th style={headerStyle}>Vendor ID</th>
                            <th style={headerStyle}>User ID</th>
                            <th style={headerStyle}>Location</th>
                            <th style={headerStyle}>Date</th>
                            <th style={headerStyle}>Time</th>
                            <th style={headerStyle}>Payment Method</th>
                            <th style={headerStyle}>Payment Status</th>
                            <th style={headerStyle}>Order Status</th>
                            <th style={headerStyle}>Total</th>
                            <th style={headerStyle}>Category</th>
                            <th style={headerStyle}>Item Name</th>
                            <th style={headerStyle}>Price</th>
                            <th style={headerStyle}>Quantity</th>
                            <th style={headerStyle}>Cancel Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length > 0 ? (
                            filteredData.map((item, index) => {
                                const orderItem = item.orderItems?.[0] || {};
                                return (
                                    <tr key={index}>
                                        <td style={cellStyle}>{item.orderId}</td>
                                        <td style={cellStyle}>{item.vendorId}</td>
                                        <td style={cellStyle}>{item.userId}</td>
                                        <td style={cellStyle}>{item.location || "-"}</td>
                                        <td style={cellStyle}>
                                            {new Date(item.orderDateAndTime).toLocaleDateString()}
                                        </td>
                                        <td style={cellStyle}>
                                            {new Date(item.orderDateAndTime).toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })}
                                        </td>
                                        <td style={cellStyle}>{item.paymentMethod || "-"}</td>
                                        <td style={cellStyle}>{item.paymentStatus || "-"}</td>
                                        <td style={cellStyle}>{item.orderStatus || "-"}</td>
                                        <td style={cellStyle}>
                                            ₹{item.total ? Math.round(item.total) : "-"}
                                        </td>
                                        <td style={cellStyle}>
                                            {orderItem.groceryCategory || "-"}
                                        </td>
                                        <td style={cellStyle}>
                                            {orderItem.groceryItemName || "-"}
                                        </td>
                                        <td style={cellStyle}>
                                            ₹{orderItem.groceryPrice || "-"}
                                        </td>
                                        <td style={cellStyle}>{orderItem.quantity || "-"}</td>
                                        <td style={cellStyle}>{item.cancelReason || "-"}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td
                                    colSpan="15"
                                    style={{ textAlign: "center", fontStyle: "italic" }}
                                >
                                    No data matches your filters.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// ✅ Styles
const headerStyle = {
    backgroundColor: "#b15cd6",
    color: "#fff",
    textAlign: "center",
    padding: "8px",
    border: "1px solid #ddd",
};

const cellStyle = {
    textAlign: "center",
    padding: "8px",
    border: "1px solid #ddd",
};

export default GroceryOrderdetails;
